import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { RsimProfileStatus } from 'src/rSimInventory/RSimApi/rSimApi.interface';
import InfoIcon from 'assets/images/info.svg';
import { pxToRem } from 'src/common/utils/fonts';
import { useTranslation } from 'react-i18next';
import { Suspense, useCallback, useState } from 'react';
import { RSimConfigurationDialog } from 'src/rSimInventory/Components/Dialogs/RSimConfigurationDialog';

type OtaConfigurationDetailsProps = {
  euicc: string;
  otaRsimDetails?: {
    isCustomConfigurationDetected: boolean;
    appliedOtaConfigurationProfile: string;
    appliedOtaConfigurationVersion: string;
    isPendingConfiguration: boolean;
    status: RsimProfileStatus;
  };
};

export const OtaConfigurationDetails = ({
  euicc,
  otaRsimDetails,
}: OtaConfigurationDetailsProps) => {
  const { t } = useTranslation();

  const [configurationDialogOpen, setConfigurationDialogOpen] = useState(false);

  const handleOnClose = useCallback(() => {
    setConfigurationDialogOpen(false);
  }, []);

  return (
    <>
      {(otaRsimDetails?.isCustomConfigurationDetected ||
        otaRsimDetails?.appliedOtaConfigurationProfile ||
        otaRsimDetails?.status !== RsimProfileStatus.Unknown) && (
        <Box
          sx={{
            display: 'flex',
            cursor: 'pointer',
            alignItems: 'center',
            mr: 16,
          }}
          onClick={() => {
            setConfigurationDialogOpen(true);
          }}
        >
          <InfoIcon
            width={pxToRem(20)}
            height={pxToRem(20)}
            role="img"
            data-testid="configuration-details-icon"
          />
          <Typography
            variant="h4"
            color="text.secondary"
            sx={{
              ml: 6,
              mt: 4,
            }}
          >
            {t('rSimInventory.configurationDetails')}
          </Typography>
        </Box>
      )}
      <Box sx={{ position: 'absolute' }}>
        <Suspense>
          <RSimConfigurationDialog
            open={configurationDialogOpen}
            data={{
              euicc,
              appliedOtaConfigurationProfile: otaRsimDetails?.appliedOtaConfigurationProfile ?? '',
              appliedOtaConfigurationVersion: otaRsimDetails?.appliedOtaConfigurationVersion ?? '',
              isPendingConfiguration: otaRsimDetails?.isPendingConfiguration ?? false,
              isCustomConfigurationDetected: otaRsimDetails?.isCustomConfigurationDetected ?? false,
            }}
            onClose={handleOnClose}
          />
        </Suspense>
      </Box>
    </>
  );
};
